import { FormControlLabel, MenuItem, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseTextField } from 'src/legacy/components/TextField';
import { DividersAndCardBorders, GraySmall } from 'src/theme/colors';

const useStyles = makeStyles()((theme) => ({
  radioOptionDescription: {
    color: GraySmall,
    marginTop: theme.spacing(0.5),
  },
  radioLabelWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  radioControlWrapper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  linkRadioControlWrapper: {
    borderTop: `1px solid ${DividersAndCardBorders}`,
  },
  radioGroup: {
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${DividersAndCardBorders}`,
    borderBottom: `1px solid ${DividersAndCardBorders}`,
  },
}));

interface ExtensionViewTypeProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  onBlur:
    | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | React.FocusEventHandler<HTMLDivElement>;
  selectType?: 'dropdown' | 'radiogroup';
  fieldName?: string;
}

export enum ExtensionViewTypeValue {
  EMBED = 'embed',
  LINK = 'link',
}
export const ExtensionViewType: React.FC<ExtensionViewTypeProps> = ({
  value,
  onChange,
  onBlur,
  selectType = 'radiogroup',
  fieldName,
}) => {
  const { classes } = useStyles();

  /**
   * When extension view type is used as a dropdown (select)
   * use this event handler.
   * @param event
   */
  const handleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dropdownSelectedItem = event.target.value;
    console.info('dropdownSelectedItem', dropdownSelectedItem);
    onChange(event, dropdownSelectedItem);
  };

  if (selectType === 'dropdown') {
    return (
      <BaseTextField
        select
        value={value}
        defaultValue="embed"
        sizeVariant="medium"
        fullWidth
        variant="outlined"
        onChange={handleSelectChange}
        name={fieldName}
        // text field on blur event occurs on HTMLInputElement|HTMLTextAreaElement
        onBlur={
          onBlur as React.FocusEventHandler<
            HTMLInputElement | HTMLTextAreaElement
          >
        }
      >
        <MenuItem value="embed">
          Show as embed - App shows directly in your Portal
        </MenuItem>
        <MenuItem value="link">
          Show as link - App opens in a new browser tab
        </MenuItem>
      </BaseTextField>
    );
  }

  return (
    <RadioGroup
      defaultValue={ExtensionViewTypeValue.EMBED}
      value={value}
      onChange={onChange}
      className={classes.radioGroup}
      name={fieldName}
      // radio blur event occurs on HTMLDivElement
      onBlur={onBlur as React.FocusEventHandler<HTMLDivElement>}
    >
      <div className={classes.radioControlWrapper}>
        <FormControlLabel
          value={ExtensionViewTypeValue.EMBED}
          control={<Radio size="small" color="primary" />}
          label={
            <div className={classes.radioLabelWrapper}>
              <BaseTypography fontType="12Medium">
                Connected as embed (recommended)
              </BaseTypography>
              <BaseTypography
                className={classes.radioOptionDescription}
                fontType="12Regular"
              >
                App shows directly in your portal
              </BaseTypography>
            </div>
          }
        />
      </div>
      <div
        className={`${classes.radioControlWrapper} ${classes.linkRadioControlWrapper}`}
      >
        <FormControlLabel
          value={ExtensionViewTypeValue.LINK}
          control={<Radio size="small" color="primary" />}
          label={
            <div className={classes.radioLabelWrapper}>
              <BaseTypography fontType="12Medium">
                Connected as link
              </BaseTypography>
              <BaseTypography
                className={classes.radioOptionDescription}
                fontType="12Regular"
              >
                App opens in a new browser tab
              </BaseTypography>
            </div>
          }
        />
      </div>
    </RadioGroup>
  );
};
